<template>
	<div>
		<div style="padding: 0 0 ;">
			<div class="p_m_t_30 overflow p_m_l_60 p_m_r_60 " :style="{ height: height + 'px' }">
				<div class="list_box p_b_b" v-for="(item, index) in count" :key="index"
					 infinite-scroll-disabled="disabled">
					<div class="p_flex p_f_a  p_m_t_20 type_size_16">
						<span class="type_size_22">{{ item.student_name }}</span>
						<span
							class="type_size_18 subject_color p_m_l_20">{{
								item.pass == 1 ? "优秀" : item.pass == 2 ? "良好" : item.pass == 3 ? "及格" : "不及格"
							}}</span>
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
						<div class="p_flex ">正确率</div>
						<div class="p_f_1 p_m_l_20  p_m_r_20">
							<el-progress :text-inside="true" :show-text='false' color="#00AF63" :stroke-width="20"
										 :percentage="item.exact_rate" status="success"></el-progress>
						</div>
						<span>{{ item.exact_rate }}%</span>
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
						<div class="p_flex ">用时{{ item.use_minute }}分</div>
						<div class="p_flex">
							<el-button @click='goDeatils(item.student_id)' type="success" size="mini">查看详情</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';

export default {
	props: {
		height: Number
	},
	data() {
		return {
			count: [],
			loading: false,
			num: 0
		};
	},
	components: {
		pagination
	},
	created() {
		this.get()
	},
	mounted() {
	},
	methods: {
		get(id) {
			this.$request.ajax(this).post("/api_teacher/analysis_report", {
				job_publish_id: this.$route.query.id
			}).then(res => {
				// console.log(res)
				this.$request.ajax(this).post("/api_teacher/analysis_submit_list", {
					job_publish_id: res.data.id, //作业id
					class_level_id: res.data.class_level_id, //班id
					corrects: 1,  //1 已批改 2 未批改 3 未提交
					limit: 10,
					page: id ? id : 1
				}).then(res => {
					// console.log(res)
					this.count = res.data.list
					this.num = parseInt(res.data.count)
				})
			})
		},
		goDeatils(id) {
			this.$router.push({
				path: '/AnalyseDeatils',
				query: {
					ids: id,
					id: this.$route.query.id
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../../assets/css/list.css';

.page_box {
	min-width: calc(1200px - 260px - 30px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/commponents/generallist.vue